var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as dompurify from 'dompurify';
import { injectCastleRequestToken } from '@ReactComponents/../utils/castle';
import { RedesignedLoginForm } from '@ReactComponents/RedesignedLoginForm/RedesignedLoginForm';
import { EmburseAccountsPageContainer } from '@ReactComponents/Shared/Account/EmburseAccountsPageContainer';
import * as style from './LoginPage.styl';
// @ts-ignore https://github.com/cure53/DOMPurify/issues/1034
const sanitize = ((_a = dompurify.default) === null || _a === void 0 ? void 0 : _a.sanitize) || dompurify.sanitize;
export const LoginPage = ({ csrf, locals }) => {
    const createErrorDiv = (className, html) => {
        const sanitized = sanitize(html); // this should be serverside html
        return _jsx("div", { className: className, dangerouslySetInnerHTML: { __html: sanitized } });
    };
    const renderErrors = () => {
        let ele;
        if ((locals === null || locals === void 0 ? void 0 : locals.error) && locals.error.length) {
            ele = createErrorDiv('error', locals.error);
        }
        else if ((locals === null || locals === void 0 ? void 0 : locals.flashError) && locals.flashError.length > 0) {
            ele = createErrorDiv('error', locals.flashError);
        }
        else if ((locals === null || locals === void 0 ? void 0 : locals.flashSuccess) && locals.flashSuccess.length > 0) {
            ele = createErrorDiv('flashSuccess', locals.flashSuccess);
        }
        return ele;
    };
    function onSubmit(e) {
        injectCastleRequestToken(e);
        e.nativeEvent.submitter.disabled = true;
        setTimeout(() => {
            e.nativeEvent.submitter.disabled = false;
        }, 2000); // in case of an unexpected error (e.g network issue), allows the form to be submitted again after a short delay
    }
    return (_jsx("div", Object.assign({ className: style.global }, { children: _jsxs("div", Object.assign({ className: "onboardingWrapper" }, { children: [renderErrors(), _jsx(EmburseAccountsPageContainer, { children: _jsx(RedesignedLoginForm, { csrf: csrf, onSubmit: onSubmit }) })] })) })));
};
